import type { ReactElement } from 'react'

import { Seo } from '@ui/components/seo'
import { HeroBasic } from '@ui/hero'
import { MarketingLayout } from '@ui/layout/MarketingLayout'
import { MainBlockCareersContainer } from '@ui/main-blocks'

const title = 'Careers & Job Openings'
const description = ''

export function Index() {
  return (
    <>
      <Seo title={title} description={description} />
      <div className="relative bg-[url('/img/our-mission-bg.svg')] bg-cover bg-center pt-[120px]">
        <HeroBasic
          className="!bg-transparent"
          title={
            <span className="font-display tracking-wider text-[#0a2d4a]">
              CAREERS
            </span>
          }
          description="Search and apply to your dream career here with ATM.com&reg;"
        />
      </div>
      <MainBlockCareersContainer />
    </>
  )
}

Index.getLayout = (page: ReactElement) => (
  <MarketingLayout chin="white" banner={false} mainClassName="-mt-[120px]">
    {page}
  </MarketingLayout>
)

export default Index
